import { environment } from 'src/environments/environment';
import { IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { BRANDING_CONFIG } from '../core/constants/branding.constants';
import { OktaAuthModel } from './../../account/core/models/auth.model';

export function buildDynamicMsalInstance(tenantConfig?: OktaAuthModel): IPublicClientApplication {
  const clientId = BRANDING_CONFIG?.AZURE_CLIENT_ID?.trim() || tenantConfig?.audience || environment.azureClientId;
  const authority = BRANDING_CONFIG?.AZURE_AUTHORITY?.trim() || tenantConfig?.issuer || environment.azureAuthority;
  const redirectUri = BRANDING_CONFIG?.AZURE_REDIRECT_URL?.trim() || tenantConfig?.azureRedirectUrl || environment.azureRedirectUrl;

  return new PublicClientApplication({
    auth: {
      clientId,
      authority,
      redirectUri,
    },
    cache: {
      cacheLocation: 'localStorage'
    },
  });
}

export function DefaultMsalInstanceFactory(): IPublicClientApplication {
  return buildDynamicMsalInstance(); 
}